import { useMediaQuery } from 'react-responsive'

function useMediaQueries(){
    const isXsMin = useMediaQuery({ minWidth: 0 })
    const isSmMin = useMediaQuery({ minWidth: 576 })
    const isMdMin = useMediaQuery({ minWidth: 768 })
    const isLgMin = useMediaQuery({ minWidth: 992 })
    const isXlMin = useMediaQuery({ minWidth: 1200 })
    const isXxlMin = useMediaQuery({ minWidth: 1400 })
    const isPortrait = useMediaQuery({ orientation: 'portrait' })
    const isRetina = useMediaQuery({ minResolution: '2dppx' })
    const isTabletOrMobileDevice = useMediaQuery({ maxDeviceWidth: 1224 })
    const isDesktopOrLaptop = useMediaQuery({ minDeviceWidth: 1224 })

    return {
        isXsMin,
        isSmMin,
        isMdMin,
        isLgMin,
        isXlMin,
        isXxlMin,
        isPortrait,
        isRetina,
        isTabletOrMobileDevice,
        isDesktopOrLaptop
    }
}

export default useMediaQueries;